import { render, staticRenderFns } from "./vue-scrollbar.vue?vue&type=template&id=6e41e052&"
import script from "./vue-scrollbar.vue?vue&type=script&lang=js&"
export * from "./vue-scrollbar.vue?vue&type=script&lang=js&"
import style0 from "./vue-scrollbar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports